<script>
import styled from 'vue-styled-components'

const ResultsImageProps = {
  level: {
    type: String,
    default: 'low'
  }
}

export default styled('div', ResultsImageProps)`
padding: 18% 50%;
background-size: contain;
background-position: center;
background-repeat: no-repeat;
background-image: ${({ level }) =>
  `url(/img/risk_imgs/screener-${level}_risk.png)`};
`
</script>
